/**
 * SectionHeader
 *
 * Props:
 *   title      – string shown as the heading
 *   onSeeAll   – optional callback; renders the "See All →" button when provided
 */
export default function SectionHeader({ title, onSeeAll }) {
  return (
    <div className="section-hdr">
      <h2>{title}</h2>
      {onSeeAll && (
        <button className="see-all-btn" onClick={onSeeAll}>
          See All →
        </button>
      )}
    </div>
  );
}
